import { render, staticRenderFns } from "./mfa-setup.vue?vue&type=template&id=3e6b9b4e&scoped=true&"
import script from "./mfa-setup.vue?vue&type=script&lang=js&"
export * from "./mfa-setup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6b9b4e",
  null
  
)

export default component.exports